import router from '../router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import cookie from '@/api/cookie';
import store from '@/store';
const config = require('../../config');

NProgress.configure({ showSpinner: false });

let whiteList = ['/login', '/error/404']; //白名单，不校验登录

//鹰眼主入口白名单
if (config.WEB == 6) {
  whiteList = whiteList.concat(['/index', '/index-rj', '/index-xh', '/index-about', '/map']);
}

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (whiteList.filter((item) => item == to.path || item + '/' == to.path).length) {
    next();
    return;
  }

  if (to.query.token) {
    cookie.setToken(to.query.token);
    delete to.query.token;
  }

  const hasToken = cookie.getToken();
  if (config.WEB != 1) {
    let loginStatus = store.state.user.loginStatus;
    if (!loginStatus) {
      loginStatus = await store.dispatch('user/updateLoginStatus');
    }
    if (hasToken && loginStatus == 3) {
      window.location.href = `${config.API_BASE}/login`;
      return;
    }
  }

  const alreayGeneraterMenus = store.getters.alreayGeneraterMenus;

  if (hasToken && alreayGeneraterMenus) {
    next();
    return;
  }

  if (hasToken) {
    let userInfo = await store.dispatch('user/getUserInfo');
    if (userInfo.has_auth == 2) {
      store.commit('router/UPDATE_MENUS_STATUS', true);
      next({ path: '/no-auth', replace: true });
      return;
    }

    //user_type = 2 运营方
    if (userInfo.user_type == 2) {
      const menus = await store.dispatch('user/getMenus');
      if (userInfo.level == 3) {
        menus.find((item) => item.path.includes('/city')).is_show = 2;
        menus.find((item) => item.path.includes('/permission-account')).is_show = 2;
      }
      const accessRoutes = await store.dispatch('router/generateRoutes', menus);
      router.addRoutes(accessRoutes);
    } else {
      store.commit('router/UPDATE_MENUS_STATUS', true);
    }
    next({ ...to, replace: true });
    return;
  }

  if (!hasToken) {
    if (config.WEB == 1 || process.env.NODE_ENV == 'development') {
      next('/login');
    } else {
      window.location.href = `${config.API_BASE}/login`;
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
